import { useState } from "react";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { cn } from "../../../lib/utils";
import { useWrapper } from "../../../hooks/wrapper.hook";

const MoreOptions = ({ options = [], customTrigger, dropdownContentProps }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
			<DropdownMenu.Trigger asChild>
				{customTrigger || (
					<button
						type="button"
						className="button line x_small whitespace-nowrap data-[state=open]:!outline outline-interactive-50"
					>
						<span className="icon_16 default options -ml-2"></span>
						<span>Altre azioni</span>
					</button>
				)}
			</DropdownMenu.Trigger>

			{/* Content DropDown */}
			<DropdownMenu.Portal>
				<DropdownMenu.Content
					className={cn(
						"m-[12px] data-[state=open]:animate-[popoverIn_.2s_forwards]",
						dropdownContentProps?.className
					)}
					align="end"
					alignOffset={-12}
				>
					<div className="bg-white shadow-[0_10px_20px] shadow-dark-90/10 border border-dark-10 rounded-[10px] divide-y divide-dark-10 overflow-hidden">
						{options.map((option, i) => (
							<OptionItem
								key={i}
								onClick={() => {
									option?.onClick?.();
									setIsOpen(false);
								}}
								wrapper={option.wrapper}
							>
								{option.label}
								{option.icon && <div className={cn("flex-none flex", option.icon)} />}
							</OptionItem>
						))}
					</div>
				</DropdownMenu.Content>
			</DropdownMenu.Portal>
		</DropdownMenu.Root>
	);
};

const OptionItem = ({ onClick, children, wrapper = undefined }) => {
	const { Wrapper, wrapperProps } = useWrapper(wrapper, "button");

	return (
		<Wrapper
			className="py-[6px] px-[12px] flex justify-between gap-[16px] text-[13px] text-left whitespace-nowrap items-center w-full hover:bg-interactive-10 transition-colors"
			onClick={onClick}
			{...(Wrapper === "button" && { type: "button" })}
			{...wrapperProps}
		>
			{children}
		</Wrapper>
	);
};

export default MoreOptions;
